import { render, staticRenderFns } from "./LandingAfiliadoAlert.vue?vue&type=template&id=746255d0"
import script from "./LandingAfiliadoAlert.vue?vue&type=script&lang=js"
export * from "./LandingAfiliadoAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports